import { formatNumber as formatI18nNumber } from '@/util/i18n/format-number';
import { formatUnits } from 'viem';

/**
 * Simple number formatting utility for liquidity positions
 * Uses en-US locale by default with configurable decimal places
 */
export function formatNumber(
  value: number, 
  decimals: number = 2,
  options: Intl.NumberFormatOptions = {}
): string {
  const defaultOptions: Intl.NumberFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
    ...options,
  };

  return formatI18nNumber(value, 'en-US', defaultOptions);
}

export function tokenFormatNumber(
  value: number, 
  decimals: number = 18,
  options: Intl.NumberFormatOptions = {}
): string {
  // change depending on length of number. for large supply tokens we should use compact notation
  const tokenValue = value * 10 ** decimals;
  const length = tokenValue.toString().length;
  if (length > 9) {
    return formatCompactNumber(Number(tokenValue));
  }
  if (length > 6) {
    return formatI18nNumber(Number(tokenValue), 'en-US', { ...options, minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  if (length > 3) {
    return formatI18nNumber(Number(tokenValue), 'en-US', { ...options, minimumFractionDigits: 0, maximumFractionDigits: 3 });
  }
  return formatI18nNumber(Number(tokenValue), 'en-US', { ...options, minimumFractionDigits: 0, maximumFractionDigits: 1 });
}

/**
 * Format number with compact notation (K, M, B)
 */
export function formatCompactNumber(value: number): string {
  return formatI18nNumber(value, 'en-US', {
    notation: 'compact',
    compactDisplay: 'short',
  });
}

/**
 * Format percentage with % symbol
 */
export function formatPercentage(value: number, decimals: number = 1): string {
  return formatI18nNumber(value, 'en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
}

/**
 * Format currency in USD
 */
export function formatUSD(value: number, decimals: number = 2): string {
  return formatI18nNumber(value, 'en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
}
















